module.exports = __webpack_public_path__ + "static/media/carosole2.b9f67e13.jpg";